module.exports = __webpack_public_path__ + "img/rollout-icon-active.1714e856.svg";